import type { ModuleGate } from '@/shell/model/module-catalog';
import { TOOLS_USE } from './use-tools-permissions';

/**
 * Who sees Strumenti: the ONE place the rule lives (#387), read by the rail entry and by the route
 * gate. Decision 100: org members of an organization entitled to the module, which the server
 * resolves into `tools:use` (read through `useToolsPermissions`).
 */
export const TOOLS_GATE: ModuleGate = { kind: 'permission', anyOf: [TOOLS_USE] };
